import { Injectable, ViewChild, ElementRef } from '@angular/core';
import { tap, catchError, map, finalize, switchMap, mergeMap } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { beatBlipSubscriptionConsts } from './consts/beatBlipSubscriptionConsts';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpHeaders
} from '@angular/common/http';
// import { Observable } from 'rxjs/Observable';
import { LoginData } from './_models/loginData';
import { CookieService } from 'ngx-cookie-service';
import { SecurityService } from './_services/security.service';
import { Observable, from, of, throwError } from 'rxjs';
import { SpinnerService } from './_services/spinner.service';
import { TestService } from './_services/test.service';
import { clear } from 'console';
import { defer } from 'rxjs';
import { EncryptedServiceService } from './_services/encrypted-service.service';
import * as CryptoTS from 'crypto-ts';
import * as CryptoJS from 'crypto-js'
import { environment } from 'src/environments/environment';

@Injectable()
export class MyInterceptor implements HttpInterceptor {
  @ViewChild('cancelmodal', null) cancelmodal: ElementRef;
  private totalRequests = 0;
  skipSpinner = ['/testReport/projectReport', '/testReport/allProjectTestDataDetailSummary', '/heirarchy/counts', 'access/automations/count', 'project/resource/count/', '/testReport/runTime', 'testReport/duration/', '/testReport/runtime/cumulative', 'automation-images/', '/suggest', 'redaction-start', 'extraction-start', '/access/companyAccountCustomers'];


  skipEncrypt = ['check-shared','send-filters','get-selected-fields', 'store-selected-fields', 'redaction-time-estimate', 'accept-redacted-file', 'get-user-settings', 'save-user-settings', 'estimate-time', 'redaction-start', 'getToBeProcessedFiles', 'copyFilesToAccepted', 'getAcceptedFiles', 'extraction-start', 'viewResultsRedaction', 'viewResultsExtraction', 'filterViewResults','/load/workflow/','/user/restricted','/workflowFeatureFlag','workflow/permissions','/workflow/list','/workflow/group','/workflow/assignee/task','8443/user/','/workflow/task/', 'workflow/node/execute', 'workflow/start/variable/','/lock','/workflow/restricted','/artifacts/upload','/artifacts/download/', '/user/all', '/workflow/identifier/validate','/configflags','/access/tokenlogin'];
  workFlowApis = ['/load/workflow/','/user/restricted','/workflowFeatureFlag','workflow/permissions','/workflow/list','/workflow/group','/workflow/assignee/task','8443/user/','/workflow/list','/workflow/task/', 'workflow/node/execute','/workflow/restricted', 'workflow/start/variable/','/lock','/artifacts/upload','/artifacts/download/', '/user/all', '/workflow/identifier/validate'];



  encryptedEnable: boolean;
  constructor(
    private cookieService: CookieService,
    private securityService: SecurityService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private spinnerService: SpinnerService,
    private testService: TestService,
    private encryptedService: EncryptedServiceService
  ) {
   this.encryptedEnable = environment.encryptedEnable
  }
  // function which will be called for all http calls
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> 
  {
    // DEVOPS-2256: send the HttpOnly session cookie on every request so the server can
    // authenticate the browser via the cookie (it reads cookie OR header). Additive — the
    // Authorization header is still set below, so nothing breaks. Set once here; the branch
    // clones below re-derive from `request`, preserving withCredentials.
    request = request.clone({ withCredentials: true });

    // tslint:disable-next-line: indent
    // how to update the request Parameters
    // tslint:disable-next-line: indent
    if(this.encryptedEnable){
    if (this.cookieService.get('loginSubscriptionData')) {
      let skipSpinner = false;
      this.skipSpinner.forEach((element) => {
        if (request.url.includes(element)) {
          skipSpinner = true;
        }
      })
      if (!skipSpinner) {
        this.totalRequests++;
        this.spinnerService.isLoading.next(true);
      }

      const loginData = JSON.parse(this.cookieService.get('loginSubscriptionData'));
      if (request.url.includes('test/copyTestCase') || request.url.includes('test/copyTestSuite') || request.url.includes('test/includeTestSuite') || request.url.includes('test/moveTestCase/') ) {
        let headers = new HttpHeaders().set("Authorization", 'Basic ' + this.securityService.base64Encode('Bearer:' + loginData.access_token)).set("Content-Type", "application/json; charset=utf-8");

        let AuthRequest;
        if (request.url == beatBlipSubscriptionConsts.AGREEYA_SF_URL) {
          AuthRequest = request;
        }
        else {
          request = request.clone({ headers: headers });
        }
        if (request.method.toLowerCase() == 'post' || request.method.toLowerCase() == 'put') {
          // request =  request.clone({
          //   body: this.encryptedService.encryptionAES(request.body)
          // })
          const encryptedBody = {
            "data": this.encrypt(request.body)
          }
          // const encryptedBody = this.encryptData(JSON.stringify(request.body));
          request = request.clone({
            body: encryptedBody,
          });
          console.log("encrypt : ", encryptedBody);
        }
        //  if(!request.url.includes('automation-images/')){
        return next.handle(request).pipe(
          map(event => {
            console.log("insucc" + event);
            if (event instanceof HttpResponse) {
              console.log("insucc" + event);
              if (event instanceof HttpResponse) {
                if (!request.url.includes('automation-images/') && event.body !== null && event.body !== "") {
                  const decryptData = event.body;
                  const _body = this.decrypt(decryptData['data']);
                  event = event.clone({ body: JSON.parse(_body) })
                  return event;
                }
                else {
                  return event;
                }
              }
            }
          }),
          catchError((httpErrorResponse: HttpErrorResponse) => {
            const decryptData = httpErrorResponse.error;
            const _body = this.decrypt(decryptData['data']);
            // event =  event.clone({body:JSON.parse(_body)})
            const newHttpErrorResponse = new HttpErrorResponse({
              error: JSON.parse(_body),
            });
            var err = newHttpErrorResponse
            if (err) {
              if (err.url == beatBlipSubscriptionConsts.AGREEYA_SF_URL) {
                if (err.status == 200) {
                  window.open(beatBlipSubscriptionConsts.AGREEYA_SF_URL, '_blank');
                } else {
                  this.toastr.clear();
                  this.toastr.error("Unable to process request. Please try again later");
                }
              } else if (err.status === 500) {
                if (this.cancelmodal) {
                  this.cancelmodal.nativeElement.click()
                }
                this.cookieService.delete('loginSubscriptionData', "/");
                this.router.navigate(["/login"]);
                this.toastr.clear();
                this.toastr.error("Unable to process request. kindly login again to use HuLoop");
              }
              else if (err.status === 401) {
                if (this.cancelmodal) {
                  this.cancelmodal.nativeElement.click()
                }
                this.cookieService.delete('loginSubscriptionData', "/");
                this.router.navigate(["/login"]);
                // this.toastr.clear();
                // this.toastr.error("Unable to process request. kindly login again to use BeatBlip");
              }
              else if (err.error && (err.error.errorCode === '981' || err.error.errorCode === '982' || err.error.errorCode === '983' || err.error.errorCode === '984' || err.error.errorCode === '401')) {
                if (this.cancelmodal) {
                  this.cancelmodal.nativeElement.click()
                }
                this.cookieService.delete('loginSubscriptionData', "/");
                this.router.navigate(["/login"]);
                //this.elem.nativeElement.querySelectorAll('.modal-backdrop');
                this.toastr.clear();
                this.toastr.error(beatBlipSubscriptionConsts.SESSION_EXPIRED);
              } 
              else if(err.error.message == "Customer Acces Token has been expired"){
                this.cookieService.delete('loginSubscriptionData', "/");
                this.router.navigate(["/login"]);
              }
              else if(err.error.message == "Company has created Maximum Automation(s)"){
                this.toastr.clear();
                this.toastr.error(err.error.message);
              }
              else {

                this.toastr.clear();
                this.toastr.error(err.error.message);
              }
            }
            return of(err);
          }),
          finalize(() => {
            console.time();
            console.timeEnd();
            let skipSpinner = false;
            this.skipSpinner.forEach((element) => {
              if (request.url.includes(element)) {
                skipSpinner = true;
              }
            })
            if (!skipSpinner) {
              this.totalRequests--;
            }

            if (this.totalRequests === 0) {
              this.spinnerService.isLoading.next(false);
            }
          })
        );
        //  }
      }
      else if (request.url.includes('testImport/uploadTestCase') || request.url.includes('textData/upload') || request.url.includes('testImport/uploadTestCase')  || request.url.includes('file-upload/upload') || request.url.includes('testImport/uploadSelenium') || request.url.includes('access/update-profile') || request.url.includes('projectCultureImport/uploadCulture') || request.url.includes('projectImport/upload') || request.url.includes('projectExport/export') || request.url.includes('testReport/pdfReport') || request.url.includes('/access/update-display-view') ||request.url.includes('/locator/editLocatorSuite') ||request.url.includes('/locator/locatorSuite') ||request.url.includes('/access/getUserProfileById') || request.url.includes('/access/delete-profile')|| request.url.includes('/access/current-user') || request.url.includes('/test/testCaseData') || request.url.includes('/test/testData') ||request.url.includes('access/generatetoken')) {
        let headers = new HttpHeaders().set("Authorization", 'Basic ' + this.securityService.base64Encode('Bearer:' + loginData.access_token));

        let AuthRequest;
        if (request.url == beatBlipSubscriptionConsts.AGREEYA_SF_URL) {
          AuthRequest = request;
        }
        else {
          AuthRequest = request.clone({ headers: headers });
        }

        return next.handle(AuthRequest).pipe(
          tap(event => {
            console.log("insucc" + event);
            if (event instanceof HttpResponse) {
              console.log("insucc" + event);
           
            }
          }),
          catchError((err: HttpErrorResponse) => {
            if (err) {
              if (err.url == beatBlipSubscriptionConsts.AGREEYA_SF_URL) {
                if (err.status == 200) {
                  window.open(beatBlipSubscriptionConsts.AGREEYA_SF_URL, '_blank');
                } else {
                  this.toastr.clear();
                  this.toastr.error("Unable to process request. Please try again later");
                }
              }
              else if(err.url.includes("file-upload"))
              {
                if(err.status == 200)
                {
                  this.toastr.clear();
                  this.toastr.success(err.error.text);
                }
                else
                {
                  this.toastr.clear();
                  this.toastr.error(err.error);
                }
              } else if (err.status === 500) {
                if (this.cancelmodal) {
                  this.cancelmodal.nativeElement.click()
                }
                this.cookieService.delete('loginSubscriptionData', "/");
                this.router.navigate(["/login"]);
                this.toastr.clear();
                this.toastr.error("Unable to process request. kindly login again to use HuLoop");
              }
              else if (err.status === 401) {
                if (this.cancelmodal) {
                  this.cancelmodal.nativeElement.click()
                }
                this.cookieService.delete('loginSubscriptionData', "/");
                this.router.navigate(["/login"]);
                // this.toastr.clear();
                // this.toastr.error("Unable to process request. kindly login again to use BeatBlip");
              }
              else if (err.error && (err.error.errorCode === '981' || err.error.errorCode === '982' || err.error.errorCode === '983' || err.error.errorCode === '984' || err.error.errorCode === '401')) {
                if (this.cancelmodal) {
                  this.cancelmodal.nativeElement.click()
                }
                this.cookieService.delete('loginSubscriptionData', "/");
                this.router.navigate(["/login"]);
                //this.elem.nativeElement.querySelectorAll('.modal-backdrop');
                this.toastr.clear();
                this.toastr.error(beatBlipSubscriptionConsts.SESSION_EXPIRED);
              } 
              else if(err.error.message == "Customer Acces Token has been expired"){
                this.cookieService.delete('loginSubscriptionData', "/");
                this.router.navigate(["/login"]);
              }
              else {

                this.toastr.clear();
                this.toastr.error(err.error.message);
              }
            }
            return of(err);
          }),
          finalize(() => {
            console.time();
            console.timeEnd();
            let skipSpinner = false;
            this.skipSpinner.forEach((element) => {
              if (request.url.includes(element)) {
                skipSpinner = true;
              }
            })
            if (!skipSpinner) {
              this.totalRequests--;
            }

            if (this.totalRequests === 0) {
              this.spinnerService.isLoading.next(false);
            }
          })
        );

      }
      
      let headers; 
      
      let skipEncrypt = false;
      this.skipEncrypt.forEach((element) => {
        if (request.url.includes(element)) {
          skipEncrypt = true;
        }
      })
      if (!skipEncrypt) {
        headers = new HttpHeaders().set("Authorization", 'Basic ' + this.securityService.base64Encode('Bearer:' + loginData.access_token));
      }
    let addHeader = false;
    this.workFlowApis.forEach((element) => {
      if (request.url.includes(element)) {
        addHeader = true;
      }
    })
   if (addHeader) {
        headers = new HttpHeaders().set("Authorization", 'Basic '  + loginData.access_token);

        headers.set('Access-Control-Allow-Origin','*')

      }
      //clone http to the custom AuthRequest and send it to the server
      let AuthRequest;
      if (request.url == beatBlipSubscriptionConsts.AGREEYA_SF_URL) {
        AuthRequest = request;
      }
      else {
        request = request.clone({ headers: headers });
      }
      if (request.method.toLowerCase() == 'post' || request.method.toLowerCase() == 'put') {
        // request =  request.clone({
        //   body: this.encryptedService.encryptionAES(request.body)
        // })
        let encryptedBody = {
          "data": this.encrypt(JSON.stringify(request.body))
        }

        let skipEncrypt = false;
        this.skipEncrypt.forEach((element) => {
          if (request.url.includes(element)) {
            skipEncrypt = true;
          }
        })
        if (skipEncrypt) {
          encryptedBody = request.body
        }

        // const encryptedBody = this.encryptData(JSON.stringify(request.body));
        request = request.clone({
          body: encryptedBody,
        });
        console.log("encrypt : ", encryptedBody);
      }
      //  if(!request.url.includes('automation-images/')){
      return next.handle(request).pipe(
        map(event => {
          if (event instanceof HttpResponse) {

            let skipEncrypt = false;
            this.skipEncrypt.forEach((element) => {
              if (request.url.includes(element)) {
                skipEncrypt = true;
              }
            })

            if (!request.url.includes('automation-images/') && event.body !== null && event.body !== "" && !skipEncrypt) {
              const decryptData = event.body;
              const _body = this.decrypt(decryptData['data']);
              event = event.clone({ body: JSON.parse(_body) })

              return event;
            }
            else {
              return event;
            }
          }

        }),
        catchError((httpErrorResponse: HttpErrorResponse) => {

          const decryptData = httpErrorResponse.error;
          let _body;

          if (!skipEncrypt) {
             _body = this.decrypt(decryptData['data']);
          }
          else
          {
            _body = decryptData;
            this.toastr.clear();
            if(!request.url.includes("workflowFeatureFlag") && 
            !request.url.includes("/user/")) {
            this.toastr.error(_body.message);
          }
          }

          // event =  event.clone({body:JSON.parse(_body)})
          const newHttpErrorResponse = new HttpErrorResponse({
            error: JSON.parse(_body),
          });
          var err = newHttpErrorResponse
          if (err) {

            if (err.url == beatBlipSubscriptionConsts.AGREEYA_SF_URL) {
              if (err.status == 200) {
                console.log(err);
                window.open(beatBlipSubscriptionConsts.AGREEYA_SF_URL, '_blank');
              } else {
                this.toastr.clear();
                this.toastr.error("Unable to process request. Please try again later");
              }
            } else if (err.status === 500 && request.url.includes('exportTestSuiteDataAsJunit')) {
              if (this.cancelmodal) {
                this.cancelmodal.nativeElement.click()
              }
              this.toastr.clear();
              this.toastr.error("There is error in file");
            }
            else if (err.status === 1300) {
              var errorMsg = err.error.message;
              var splitMessage = errorMsg.substring(0, errorMsg.lastIndexOf(':'));
              var CaptureSuiteName = errorMsg.substring(errorMsg.lastIndexOf(':'), errorMsg.length).split(',');
              this.toastr.clear();
              this.toastr.error(splitMessage + '/module ' + '(' + CaptureSuiteName[2] + ')');
            }
            else if (err.status === 401) {
              if (err.error.errorCode === '902') {
                this.toastr.clear();
                this.toastr.error(err.error.message);
              }
              else if (err.error.errorCode === '900') {
                this.router.navigate(["/project/home"]);
                this.toastr.clear();
                this.toastr.error(err.error.message);
              }
              else {
                this.cookieService.delete('loginSubscriptionData', "/");
                this.router.navigate(["/login"]);
                //this.elem.nativeElement.querySelectorAll('.modal-backdrop');
                this.toastr.clear();
                this.toastr.error(beatBlipSubscriptionConsts.SESSION_EXPIRED);
              }
            }

            // else if(err.status===933){
            //   if(err.error.errorCode === '933')
            //   {
            //     this.toastr.clear();
            //     this.toastr.error(err.error.message);
            //   }

            // }
            else if (err.error && (err.error.errorCode === '981' || err.error.errorCode === '982' || err.error.errorCode === '983' || err.error.errorCode === '984' || err.error.errorCode === '1102')) {
              if (this.cancelmodal) {
                this.cancelmodal.nativeElement.click()
              }
              this.cookieService.delete('loginSubscriptionData', "/");
              this.router.navigate(["/login"]);
              //this.elem.nativeElement.querySelectorAll('.modal-backdrop');
              this.toastr.clear();
              this.toastr.error(beatBlipSubscriptionConsts.SESSION_EXPIRED);
            }
            else if(err.error.message == "Customer Acces Token has been expired"){
              this.cookieService.delete('loginSubscriptionData', "/");
              this.router.navigate(["/login"]);
            }
            else {

              this.toastr.clear();
              this.toastr.error(err.error.message);
              // console.log(err.error.message)
              // console.log('url',request.url);
              if (request.url.includes('editTestCase')) {
                //  console.log('call the initFlowChartFunction');
                this.testService.inItFlowChartSteps.next(true);
              }

            }
           
          }
          return of(err);
        }),
        finalize(() => {
          const key = request.urlWithParams;
          // console.time();
          // console.timeEnd();
          setTimeout(() => {
            let skipSpinner = false;
            this.skipSpinner.forEach((element) => {
              if (request.url.includes(element)) {
                skipSpinner = true;
              }
            })
            if (!skipSpinner) {
              this.totalRequests--;
            }
            if (this.totalRequests === 0) {
              this.spinnerService.isLoading.next(false);
            }
          }, 0);


        })
      );
      //  }
    }
    else {
      if (request.url.includes('sso/createuser') || request.url.includes('login-user') || request.url.includes('forgot-password')
         || request.url.includes("validate-user")) {
        if (request.method.toLowerCase() == 'post' || request.method.toLowerCase() == 'put') {
          // request =  request.clone({
          //   body: this.encryptedService.encryptionAES(request.body)
          // })
          // request.body = this.encryptedService.encryptionAES(request.body.toString())
          // console.log("encrypt : ",this.encryptedService.encryptionAES(request.body.toString()));
          if (request.body != "") {
            const encryptedBody = {
              "data": this.encrypt(JSON.stringify(request.body))
            }
            console.log("encrypt : ", encryptedBody);
            //console.log("decrypted",this.decrypt(encryptedBody.data))
            request = request.clone({
              body: encryptedBody,
            });
          }


          // return from(this.encrypt(request.body)).pipe(
          //   switchMap((data) => next.handle(data)),
          //   switchMap((event) =>
          //     event instanceof HttpResponse
          //       ? from(this.decrypt(event.))
          //       : of(event)
          //   )
          // );

        }
        // if(!request.url.includes('automation-images/')){
        return next.handle(request)
          // .pipe(
          //   tap(evt => {
          //     if (evt instanceof HttpResponse) { 
          //      const decryptData = JSON.parse(evt.body);
          //      console.log('Rahul111 ', decryptData);
          //      var x = this.decrypt(decryptData['data']);
          //      evt = evt.clone({
          //       body: JSON.parse(x),
          //     });

          //     console.log('Rahul222 ', x);
          //     }
          // }
          .pipe(map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              if (!request.url.includes('automation-images/') && event.body !== null && event.body !== "") {
                const decryptData = event.body;
                const _body = this.decrypt(decryptData['data']);
                event = event.clone({ body: JSON.parse(_body) })
                console.log('gowtham222', event);
                return event;
              }
              else {
                return event;
              }
            }
          }
          ),

            catchError((httpErrorResponse: HttpErrorResponse) => {
              const decryptData = httpErrorResponse.error;
              const _body = this.decrypt(decryptData['data']);
              // event =  event.clone({body:JSON.parse(_body)})
              const newHttpErrorResponse = new HttpErrorResponse({
                error: JSON.parse(_body),
              });
              this.toastr.clear();
              this.toastr.error(newHttpErrorResponse.error.message)
              return throwError(() => newHttpErrorResponse);
              // return of(err);

            }));
        // }
      }
     else if(request.url.includes('create-free-user') || request.url.includes('/configflags')) {
    
          return next.handle(request).pipe(
            tap(evt => {
              if (evt instanceof HttpResponse) {
                  //console.log("insucc" + evt)
              }
          }),
          catchError((err: any) => {
              if(err instanceof HttpErrorResponse) {
                if (err.status===500){
                  this.cookieService.delete('loginSubscriptionData',"/");
                  this.router.navigate(["/login"]);
                  this.toastr.clear();
                  this.toastr.error("Unable to process request. kindly login again to use HuLoop");
              } else if(err.error.errorCode === '981' || err.error.errorCode === '982' || err.error.errorCode === '983' || err.error.errorCode === '984'|| err.error.errorCode === '401' || err.error.errorCode === '1102') {
                  this.cookieService.delete('loginSubscriptionData',"/");
                  this.router.navigate(["/login"]);
                  this.toastr.clear();
                  this.toastr.error(beatBlipSubscriptionConsts.SESSION_EXPIRED);
              } else if( err.error.appStatusCode === '15026' || err.error.appStatusCode === '15027' || err.error.appStatusCode === '15028'){
                  console.log(err);
                  this.cookieService.delete('loginSubscriptionData',"/");
                  this.router.navigate(["/login"]);
                  this.toastr.clear();
                  this.toastr.error(err.error.message);
              }
              else if (err.status===401){
                this.cookieService.deleteAll();
                this.cookieService.delete('loginSubscriptionData',"/");
                this.router.navigate(["/login"]);
                this.toastr.clear();
                this.toastr.error("Unable to process request. kindly login again to use HuLoop");
            } 
              else{
                console.log(err);
                this.toastr.clear();
                if (err.error && err.error.appStatusCode) {
                  this.toastr.error(err.error.message);
                } else {
                  this.toastr.error(err.error.message || "An error occurred");
                }
              }
            }
              return of(err);
          }));
        }
      else {
        // this.router.navigate(["/login"]);
      }

    }

  }
  else{
    if(this.cookieService.get('loginSubscriptionData')) {
      let skipSpinner = false;
      this.skipSpinner.forEach((element)=>
      {
        if(request.url.includes(element))
        {
            skipSpinner = true;
        }
      })
      if(!skipSpinner)
      { 
        this.totalRequests++;
        this.spinnerService.isLoading.next(true);
      }
  
      const loginData = JSON.parse(this.cookieService.get('loginSubscriptionData'));
      if( request.url.includes('test/copyTestCase')|| request.url.includes('test/copyTestSteps') || request.url.includes('test/moveTestCase/')|| request.url.includes('test/copyTestSuite') || request.url.includes('test/includeTestSuite') ){
        let headers = new HttpHeaders().set("Authorization", 'Basic ' + this.securityService.base64Encode('Bearer:' + loginData.access_token)).set("Content-Type","application/json; charset=utf-8");
       
        let AuthRequest;
        if(request.url == beatBlipSubscriptionConsts.AGREEYA_SF_URL){
           AuthRequest = request;
         }else{
           AuthRequest = request.clone( { headers: headers});
         }
         return next.handle(AuthRequest).pipe(
           tap(evt => {
         //  console.log("Event is " + evt);
           if (evt instanceof HttpResponse) {
           //    console.log("insucc" + evt)
           }
     }),
     catchError((err: any) => {
      if(err instanceof HttpErrorResponse) {
      if(err.url == beatBlipSubscriptionConsts.AGREEYA_SF_URL){
        if(err.status==200){
          window.open(beatBlipSubscriptionConsts.AGREEYA_SF_URL, '_blank');
        }else{
          this.toastr.clear();
          this.toastr.error("Unable to process request. Please try again later");
        }
      } else if (err.status===500){
        if(this.cancelmodal) {
          this.cancelmodal.nativeElement.click()
        }
        this.cookieService.delete('loginSubscriptionData',"/");
        this.router.navigate(["/login"]);
        this.toastr.clear();
        this.toastr.error("Unable to process request. kindly login again to use HuLoop");
      }
      else if (err.status===401){
        if(this.cancelmodal) {
          this.cancelmodal.nativeElement.click()
        }
        this.cookieService.delete('loginSubscriptionData',"/");
          this.router.navigate(["/login"]);
        // this.toastr.clear();
        // this.toastr.error("Unable to process request. kindly login again to use BeatBlip");
      }
        else if(err.error && (err.error.errorCode === '981' || err.error.errorCode === '982' || err.error.errorCode === '983' || err.error.errorCode === '984'|| err.error.errorCode === '401')) {
          if(this.cancelmodal) {
            this.cancelmodal.nativeElement.click()
          }
          this.cookieService.delete('loginSubscriptionData',"/");
          this.router.navigate(["/login"]);
          //this.elem.nativeElement.querySelectorAll('.modal-backdrop');
          this.toastr.clear();
          this.toastr.error(beatBlipSubscriptionConsts.SESSION_EXPIRED);
      }else{
  
        this.toastr.clear();
        this.toastr.error(err.error.message);
      }
      }
      return of(err);
  }),
  finalize(() => {
    console.time();
    console.timeEnd();
    let skipSpinner = false;
    this.skipSpinner.forEach((element)=>
    {
      if(request.url.includes(element))
      {
          skipSpinner = true;
      }
    })
    if(!skipSpinner)
    { 
      this.totalRequests--;
    }
  
    if (this.totalRequests === 0) {
      this.spinnerService.isLoading.next(false);
    }
  })
  );
      }
      else{
  
      }
      const headers = new HttpHeaders().set("Authorization", 'Basic ' + this.securityService.base64Encode('Bearer:' + loginData.access_token));
  
      //clone http to the custom AuthRequest and send it to the server
    let AuthRequest;
     if(request.url == beatBlipSubscriptionConsts.AGREEYA_SF_URL){
        AuthRequest = request;
      }else{
        AuthRequest = request.clone( { headers: headers});
      }
      return next.handle(AuthRequest).pipe(
        tap(evt => {
      
        if (evt instanceof HttpResponse) {
        //    console.log("insucc" + evt)
        }
  }),
  catchError((err: any) => {
      if(err instanceof HttpErrorResponse) {
      if(err.url == beatBlipSubscriptionConsts.AGREEYA_SF_URL){
        if(err.status==200){
          console.log(err);
          window.open(beatBlipSubscriptionConsts.AGREEYA_SF_URL, '_blank');
        }else{
          this.toastr.clear();
          this.toastr.error("Unable to process request. Please try again later");
        }
      } else if (err.status===500  && request.url.includes('exportTestSuiteDataAsJunit')){
        if(this.cancelmodal) {
          this.cancelmodal.nativeElement.click()
        }
        this.toastr.clear();
        this.toastr.error("There is error in file");
      }
     else if(err.status===1300){
      var errorMsg = err.error.message;
      var splitMessage  = errorMsg.substring(0,errorMsg.lastIndexOf(':'));
      var CaptureSuiteName = errorMsg.substring(errorMsg.lastIndexOf(':'), errorMsg.length).split(',');
       this.toastr.clear();
       this.toastr.error(splitMessage + '/module ' + '('+CaptureSuiteName[2]+')');
     }
   else if(err.status===401){
    if(err.error.errorCode === '902')
    {
      this.toastr.clear();
      this.toastr.error(err.error.message);
    }
    else if(err.error.errorCode === '900'){
      this.router.navigate(["/project/home"]);
          this.toastr.clear();
          this.toastr.error(err.error.message);
    }
    else
    {
      this.cookieService.delete('loginSubscriptionData',"/");
      this.router.navigate(["/login"]);
      //this.elem.nativeElement.querySelectorAll('.modal-backdrop');
      this.toastr.clear();
      this.toastr.error(beatBlipSubscriptionConsts.SESSION_EXPIRED);
    }
  }
  
  // else if(err.status===933){
  //   if(err.error.errorCode === '933')
  //   {
  //     this.toastr.clear();
  //     this.toastr.error(err.error.message);
  //   }
  
  // }
        else if(err.error && (err.error.errorCode === '981' || err.error.errorCode === '982' || err.error.errorCode === '983' || err.error.errorCode === '984' ||  err.error.errorCode === '1102')) {
          if(this.cancelmodal) {
            this.cancelmodal.nativeElement.click()
          }
          this.cookieService.delete('loginSubscriptionData',"/");
          this.router.navigate(["/login"]);
          //this.elem.nativeElement.querySelectorAll('.modal-backdrop');
          this.toastr.clear();
          this.toastr.error(beatBlipSubscriptionConsts.SESSION_EXPIRED);
      }
   else{
  
        this.toastr.clear();
        this.toastr.error(err.error.message);
       // console.log(err.error.message)
       // console.log('url',request.url);
        if(request.url.includes('editTestCase')){
        //  console.log('call the initFlowChartFunction');
          this.testService.inItFlowChartSteps.next(true);
        }
  
      }
      }
      return of(err);
  }),
  
  finalize(() => {
    const key = request.urlWithParams;
    // console.time();
    // console.timeEnd();
    setTimeout(() => {
      let skipSpinner = false;
      this.skipSpinner.forEach((element)=>
      {
        if(request.url.includes(element))
        {
            skipSpinner = true;
        }
      })
      if(!skipSpinner)
      { 
        this.totalRequests--;
      }
      if (this.totalRequests === 0) {
        this.spinnerService.isLoading.next(false);
      }
    }, 0);
   
  
  })
  );
  
    } 
    else {
  
      if(request.url.includes('sso/createuser') || request.url.includes('login-user') || request.url.includes('forgot-password')
      || request.url.includes('create-free-user') || request.url.includes("validate-user") || request.url.includes('/configflags')) {
  
        return next.handle(request).pipe(
          tap(evt => {
            if (evt instanceof HttpResponse) {
                //console.log("insucc" + evt)
            }
        }),
        catchError((err: any) => {
            if(err instanceof HttpErrorResponse) {
              if (err.status===500){
                this.cookieService.delete('loginSubscriptionData',"/");
                this.router.navigate(["/login"]);
                this.toastr.clear();
                this.toastr.error("Unable to process request. kindly login again to use HuLoop");
            } else if(err.error.errorCode === '981' || err.error.errorCode === '982' || err.error.errorCode === '983' || err.error.errorCode === '984'|| err.error.errorCode === '401' || err.error.errorCode === '1102') {
                this.cookieService.delete('loginSubscriptionData',"/");
                this.router.navigate(["/login"]);
                this.toastr.clear();
                this.toastr.error(beatBlipSubscriptionConsts.SESSION_EXPIRED);
            } else if( err.error.appStatusCode === '15026' || err.error.appStatusCode === '15027' || err.error.appStatusCode === '15028'){
                console.log(err);
                this.cookieService.delete('loginSubscriptionData',"/");
                this.router.navigate(["/login"]);
                this.toastr.clear();
                this.toastr.error(err.error.message);
            }
            else if (err.status===401){
              this.cookieService.deleteAll();
              this.cookieService.delete('loginSubscriptionData',"/");
              this.router.navigate(["/login"]);
              this.toastr.clear();
              this.toastr.error("Unable to process request. kindly login again to use HuLoop");
          } 
            else{
              console.log(err);
              this.toastr.clear();
              if (err.error && err.error.appStatusCode) {
                this.toastr.error(err.error.message);
              } else {
                this.toastr.error(err.error.message || "An error occurred");
              }
            }
          }
            return of(err);
        }));
      } else {
        this.router.navigate(["/login"]);
      }
  
    }
  }
  }


  // Encrypt method
  encrypt(data: string): string {
    const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), '12345');
    console.log("Encrypted:" + encrypted);
    return encrypted.toString();
  }

  // Decrypt method
  decrypt(data: string): string {
    const decrypted = CryptoJS.AES.decrypt(data, '12345')
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
}